(function () {
  'use strict';

  const ROOT_READY = 'vicsThemeReady';
  const SCROLLED_CLASS = 'vics-is-scrolled';
  const CARD_ACTIVE_CLASS = 'vics-card-active';
  const HEADER_COMPACT_CLASS = 'vics-header-condensed';
  const LEGACY_BRAND = /Zora\s*Art/gi;
  const HAS_LEGACY_BRAND = /Zora\s*Art/i;

  function replaceLegacyBrand(root) {
    const scope = root === document ? document.body : root;
    if (!scope) return;

    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, textarea, template, noscript')) {
          return NodeFilter.FILTER_REJECT;
        }
        return HAS_LEGACY_BRAND.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach((node) => {
      node.nodeValue = node.nodeValue.replace(LEGACY_BRAND, 'VICS ART');
    });

    scope.querySelectorAll('[alt], [aria-label], [title]').forEach((node) => {
      ['alt', 'aria-label', 'title'].forEach((attribute) => {
        const value = node.getAttribute(attribute);
        if (value && HAS_LEGACY_BRAND.test(value)) node.setAttribute(attribute, value.replace(LEGACY_BRAND, 'VICS ART'));
      });
    });
  }

  function setWordmark(root) {
    root.querySelectorAll('.zora-wordmark__main').forEach((node) => {
      if (node.textContent.trim() !== 'VICS') node.textContent = 'VICS';
    });

    root.querySelectorAll('.zora-wordmark__accent').forEach((node) => {
      if (node.textContent.trim() !== 'ART') node.textContent = 'ART';
    });

    root.querySelectorAll('a.zora-wordmark, .zora-wordmark[aria-label]').forEach((node) => {
      node.setAttribute('aria-label', 'VICS ART');
      node.setAttribute('title', 'VICS ART');
    });

    replaceLegacyBrand(root);

    if (root === document) {
      document.title = document.title.replace(LEGACY_BRAND, 'VICS ART');
    }
  }

  function bindProductCards(root) {
    root.querySelectorAll('.vics-product-card, .zora-product-card, product-card, .product-card').forEach((card) => {
      if (card.dataset.vicsCardBound === 'true') return;
      card.dataset.vicsCardBound = 'true';

      card.addEventListener('focusin', () => card.classList.add(CARD_ACTIVE_CLASS));
      card.addEventListener('focusout', (event) => {
        if (!card.contains(event.relatedTarget)) card.classList.remove(CARD_ACTIVE_CLASS);
      });
    });
  }

  function formatCountdownPart(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function initialiseCountdown(root) {
    root.querySelectorAll('[data-vics-countdown][data-countdown-end]').forEach((countdown) => {
      if (countdown.dataset.vicsCountdownBound === 'true') return;

      const end = Date.parse(countdown.dataset.countdownEnd);
      if (!Number.isFinite(end)) return;

      countdown.dataset.vicsCountdownBound = 'true';
      const parts = {
        days: countdown.querySelector('[data-countdown-days]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]')
      };

      const render = () => {
        const remaining = Math.max(0, end - Date.now());
        const secondsTotal = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(secondsTotal / 86400),
          hours: Math.floor((secondsTotal % 86400) / 3600),
          minutes: Math.floor((secondsTotal % 3600) / 60),
          seconds: secondsTotal % 60
        };

        Object.entries(parts).forEach(([name, node]) => {
          if (node) node.textContent = formatCountdownPart(values[name]);
        });

        if (remaining === 0) {
          window.clearInterval(timer);
          countdown.dispatchEvent(new CustomEvent('vics:countdown-ended', { bubbles: true }));
        }
      };

      const timer = window.setInterval(render, 1000);
      render();
    });
  }

  function hydrate(root) {
    setWordmark(root);
    bindProductCards(root);
    initialiseCountdown(root);
  }

  function updateHeaderState() {
    const compact = window.scrollY > 72;
    document.body.classList.toggle(SCROLLED_CLASS, compact);
    document.querySelector('#header-component')?.classList.toggle(HEADER_COMPACT_CLASS, compact);
  }

  function init() {
    if (document.documentElement.dataset[ROOT_READY] === 'true') return;
    document.documentElement.dataset[ROOT_READY] = 'true';

    hydrate(document);
    updateHeaderState();

    let scrollFrame = 0;
    window.addEventListener(
      'scroll',
      () => {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(() => {
          updateHeaderState();
          scrollFrame = 0;
        });
      },
      { passive: true }
    );

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) hydrate(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
